import React from "react";
import Ingredient from "../Ingredient";
import whole from "../../assets/images/ingredients/WholeCarrot.png";
import sliced from "../../assets/images/ingredients/CutCarrot.png";

const Carrot = ({ onClick, changeable=true, changed, hideable=true }) => {
    const handleClick = (event) => {
        event.stopPropagation();
        if (onClick) {
            onClick(event);
        }
    };
    return (
        <Ingredient
            name="Carrot"
            image={[whole, sliced]}
            changeable={changeable}
            changed={changed}
            hideable={hideable}
            onClick={handleClick}
        />
    );
};

export default Carrot;